(function () {
  "use strict";

  class ConvxComponentSlider extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.windowWidth = window.innerWidth;
    }

    connectedCallback() {
      this.initFlickity();
      window.addEventListener("resize", this.updateFlickity.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.updateFlickity.bind(this));
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    getFlickityOptions() {
      return window.innerWidth < 768
        ? {
          cellAlign: "left",
          contain: true,
          groupCells: true,
          draggable: true,
          prevNextButtons: true,
          pageDots: false,
          freeScroll: false,
          percentPosition: true,
          wrapAround: true,
          imagesLoaded: true,
          lazyLoad: 2,
          autoPlay: 5000
        }
        : {
          cellAlign: "left",
          contain: true,
          groupCells: false,
          draggable: true,
          prevNextButtons: true,
          pageDots: false,
          freeScroll: false,
          percentPosition: true,
          wrapAround: true,
          imagesLoaded: true,
          lazyLoad: 2,
          autoPlay: 5000
        };
    }

    initFlickity() {
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
      this.flickityInstance = new Flickity(this, this.getFlickityOptions());
    }

    updateFlickity() {
      if (window.innerWidth !== this.windowWidth) {
        this.windowWidth = window.innerWidth;
        this.initFlickity();
      }
    }
  }

  function onDOMContentLoaded() {
    customElements.define("convx-page-component-slider", ConvxComponentSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
